import { Common } from '../common';

import * as Notification from '../models/patient/notification';
import {
  AppointmentReply,
  AppointmentsResponse,
} from '../models/notification/intent';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getAppointments(
    authenticationCode: string,
    futureOnly = true,
  ): Promise<AppointmentsResponse> {
    const url = this.common.constructPath(
      `/patient-previsit/intents/${authenticationCode}`,
      { futureOnly },
    );
    return this.common.getJSON(url);
  }

  async postIntent(args: {
    intentId: string;
    kind: Notification.Kind;
    email?: string;
    phoneNumber?: string;
  }): Promise<{ message: string }> {
    if (!args.email && !args.phoneNumber) {
      throw new Error('At least email or phone number need to be provided.');
    }
    const url = this.common.constructPath('/patient-previsit/intents');
    return this.common.postJSON(url, args);
  }

  async processAppointmentsConfirmation({
    authenticationCode,
    appointmentReplies,
  }: {
    authenticationCode: string;
    appointmentReplies: AppointmentReply[];
  }): Promise<{
    success: boolean;
    successfullyProcessedIntentEncounterIds: string[];
  }> {
    const url = this.common.constructPath(
      `/patient-previsit/intents/v2/${authenticationCode}`,
    );
    return this.common.postJSON(url, { appointmentReplies });
  }
}
